<template>
  <div>

    <div>
      <h6 class="title is-6">Caricamento files</h6>
    </div>
    <form id='formFile' class="mt-3" :class="{'is-flex': !isMobile}" @submit.prevent="uploadFiles()">
      
      <div class="is-flex">

        <div class="file has-name" :class="{'is-boxed': isMobile, 'is-info': uploadLabelFile !== 'Nessun file selezionato', 'mr-2': isMobile}" style="min-width: 0;flex: 1 1 0px;">
          <label class="file-label">
            <input class="file-input" type="file" ref="inputFiles" multiple @change="updateLabel()" :disabled="disabledFile">
            <span class="file-cta">
              <span class="file-icon">
                <font-awesome-icon icon="upload" />
              </span>
              <span class="file-label">
                Seleziona file
              </span>
            </span>
            <span class="file-name" :class="{'is-italic': uploadLabelFile === 'Nessun file selezionato'}">
              {{uploadLabelFile}}
            </span>
          </label>
        </div>

        <div v-if="isMobile" class="file has-name" :class="{'is-boxed': isMobile, 'is-info': uploadLabelPhoto !== 'Nessun file selezionato'}" style="min-width: 0;flex: 1 1 0px;">
          <label class="file-label">
            <input class="file-input" type="file" accept="image/*" capture="camera" ref="inputFilesPhoto" multiple @change="updateLabel()" :disabled="disabledFile">
            <span class="file-cta">
              <span class="file-icon">
                <font-awesome-icon icon="camera" />
              </span>
              <span class="file-label">
                Scatta foto
              </span>
            </span>
            <span class="file-name" :class="{'is-italic': uploadLabelPhoto === 'Nessun file selezionato'}">
              {{uploadLabelPhoto}}
            </span>
          </label>
        </div>

      </div>

      <button class="button is-primary" :class="[{'is-loading': waitUploadFile || waitUploadFileCompression}, isMobile ? 'mt-2': 'ml-2']" type='submit' :disabled="disabledUploadFile">Upload</button>
    </form>
    <div class="mt-2" v-show="waitUploadFileCompression">Compressione...</div>
    <div class="mt-2" v-show="waitUploadFile">{{filesCounterProgress}}/{{filesCounterTotal}} files</div>

    <div class="table-container mt-6">
      <table class="table is-bordered is-striped is-hoverable" style="min-width: 300px; width: 100%; max-width: 800px;">
        <thead>
          <tr>
            <th>Anteprima</th>
            <th>Link</th>
            <th>Info</th>
            <th style="width: 122px;"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-show="!loadingFiles" v-for="(file, index) in files" :key="index">
            <td>
              <img v-if="checkImg(file.url)" :src="baseUrl + '/uploads/' + file.url" style="max-height: 100px;" />
            </td>
            <td>
              <a :href="baseUrl + '/uploads/' + file.url" target="_blank" :class="{'has-text-grey-light': file.deleting}">{{file.name}}</a>
            </td>
            <td>
              <div v-if="file.createdAt">{{ new Date(file.createdAt).toDisplay(true) }}</div>
              <div v-if="!file.createdAt">{{ new Date(parseInt(file.url.split('.')[0])).toDisplay(true) }}</div>
              <div v-if="file.createdBy" class="has-text-grey is-abbr-like is-size-7">{{ $fullname(file.createdBy) }}</div>
            </td>
            <td class="is-actions-cell is-justify-content-flex-end">
              <div class="buttons is-right">
                <button class="button is-warning" @click="editFileName(file)" title="Modifica">
                  <span class="icon"><font-awesome-icon icon="pen" /></span>
                </button>
                <button class="button is-danger" @click="deleteFile(file)" title="Elimina">
                  <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="loadingFiles">
            <td colspan="100"><i>Caricamento file...</i></td>
          </tr>
          <tr v-if="!loadingFiles && files.length === 0">
            <td colspan="100"><i>Nessun file</i></td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import Compressor from 'compressorjs'

export default {
  props: ['id', 'type'],
  
  data() {
    return {
      files: [],
      baseUrl: import.meta.env.VITE_SERVER,
      imageExt: ['png', 'jpg', 'jpeg', 'avif', 'webp'],

      uploadLabelFile: 'Nessun file selezionato',
      uploadLabelPhoto: 'Nessun file selezionato',

      disabledFile: false,
      disabledUploadFile: true,
      waitUploadFile: false,
      waitUploadFileCompression: false,

      loadingFiles: true,

      openModal: false,

      isMobile: false,

      filesCounterTotal: 0,
      filesCounterProgress: 0,
    }
  },

  methods: {
    getFiles() {
      const self = this

      this.loadingFiles = true

      this.$refs.inputFiles.value = ''
      if (this.$refs.inputFilesPhoto) {
        this.$refs.inputFilesPhoto.value = ''
      }
      this.updateLabel()

      this.$http.get('/file/' + self.type + '/' + this.id).then(response => {
        self.files = response.data.files
        this.loadingFiles = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.loadingFiles = false
      })
    },

    updateLabel() {
      const total = this.$refs.inputFiles.files.length

      if (total === 0) {
        this.uploadLabelFile = 'Nessun file selezionato'
        this.disabledUploadFile = true
      } else if (total === 1) {
        this.uploadLabelFile = total + ' file selezionato'
        this.disabledUploadFile = false
      } else if (total > 1) {
        this.uploadLabelFile = total + ' file selezionati'
        this.disabledUploadFile = false
      }

      if (this.$refs.inputFilesPhoto) {
        const totalPhoto = this.$refs.inputFilesPhoto.files.length

        if (totalPhoto === 0) {
          this.uploadLabelPhoto = 'Nessun file selezionato'
          if (total === 0) {
            this.disabledUploadFile = true
          }
        } else if (totalPhoto === 1) {
          this.uploadLabelPhoto = totalPhoto + ' file selezionato'
          this.disabledUploadFile = false
        } else if (totalPhoto > 1) {
          this.uploadLabelPhoto = totalPhoto + ' file selezionati'
          this.disabledUploadFile = false
        }
      }
    },

    compressFile(file) {
      return new Promise((resolve, reject) => {
        new Compressor(file, {
          quality: 0.7,
          maxWidth: 2400,
          maxHeight: 2400,
          success(result) {
            if (file.webkitRelativePath) {
              result.webkitRelativePath = file.webkitRelativePath
            }
            resolve(result)
          },
          error(err) {
            //alert('Errore compressione immagine')
            //console.log(err)
            resolve(file)
          },
        })
      })
    },

    async uploadFiles() {
      const self = this
      this.disabledFile = true
      this.disabledUploadFile = true
      this.waitUploadFileCompression = true

      this.filesCounterTotal = Array.from(this.$refs.inputFiles.files).length
      if (this.$refs.inputFilesPhoto) {
        this.filesCounterTotal += Array.from(this.$refs.inputFilesPhoto.files).length
      }

      this.filesCounterProgress = 1

      const promises = []
      for (const file of Array.from(this.$refs.inputFiles.files)) {
        promises.push(self.compressFile(file))
      }
      if (this.$refs.inputFilesPhoto) {
        for (const file of Array.from(this.$refs.inputFilesPhoto.files)) {
          promises.push(self.compressFile(file))
        }
      }

      Promise.all(promises).then(async results => {
        self.waitUploadFileCompression = false
        self.waitUploadFile = true

        for (const result of results) {
          let formData = new FormData()

          formData.append('files', result, result.name)

          await self.$http.post('/file/' + self.type + '/' + self.id, formData)

          self.filesCounterProgress++
        }

        self.getFiles()

        self.disabledFile = false
        self.waitUploadFile = false
      })
    },

    editFileName(file) {
      const self = this
      file.deleting = true

      const newName = prompt('Inserisci il nuovo nome del file', file.name)

      if (newName != null) {
        this.$http.post('/file/' + self.type + '/' + self.id + '/' + file.url + '/rename', {name: newName})
          .then(function (response) {
            self.getFiles()
          })
          .catch(function (error) {
            console.log(error)
            alert('Errore')
            file.deleting = false
          })
      } else {
        file.deleting = false
      }
    },

    deleteFile(file) {
      if (confirm('Eliminare?')) {
        const self = this
        file.deleting = true

        this.$http.delete('/file/' + self.type + '/' + self.id + '/' + file.url)
          .then(function (response) {
            self.getFiles()
          })
          .catch(function (error) {
            console.log(error)
            alert('Errore')
            file.deleting = false
          })
      }
    },

    checkImg(url) {
      return this.imageExt.find(ext => url.includes('.'+ext))
    },

    onResize () {
      this.isMobile = window.innerWidth < 900
    }
  },

  mounted() {
    this.getFiles()

    //resize input file
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  }
}
</script>